import styled from '@emotion/styled'
import { IconButton } from '@mui/material'

export const OutlinedIconButton = styled(IconButton)(({ theme }) => ({
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-disabled': {
        border: `1px solid ${theme.palette.action.disabledBackground}`,
        color: theme.palette.action.disabled,
    },
}))
